<template>
  <div class="trigger trigger-section">
    <div class="trigger-section-header trigger-section-header-orange">
      <b-icon icon="gear-fill" />
      <span>{{ $t('gatilhos-de-aderencia') }}</span>
    </div>
    <div class="trigger-section-body">

      <!-- Linha 1: ALT, ALD, ATS -->
      <div class="trigger-cards-row">

        <!-- ALT: Aderência Turno Mínima -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !altActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-5" v-model="altActive" @change="sendALT" class="trigger-checkBox" name="checkbox-5" value="true" switch :title="$t('aderencia-turno-minima')" v-marquee-overflow>
              {{ $t('aderencia-turno-minima') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ALT.title + ' - ' + triggerInfo.ALT.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.ALT.title + ' - ' + $t('explicacao-fca-4') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field trigger-unit-label"></span>
          </div>
        </div>

        <!-- ALD: Aderência Diária Mínima -->
        <div class="trigger-card" :class="{ 'trigger-card--inactive': !aldActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-6" v-model="aldActive" @change="sendALD" class="trigger-checkBox" name="checkbox-6" value="true" switch :title="$t('aderencia-diaria-minima')" v-marquee-overflow>
              {{ $t('aderencia-diaria-minima') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ALD.title + ' - ' + triggerInfo.ALD.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.ALD.title + ' - ' + $t('explicacao-fca-5') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field trigger-unit-label"></span>
          </div>
        </div>

        <!-- ATS: Turnos Sem Atingir Meta -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !atsActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-7" v-model="atsActive" @change="sendATS" class="trigger-checkBox" name="checkbox-7" value="true" switch :title="$t('turnos-sem-atingir-meta-de-aderencia')" v-marquee-overflow>
              {{ $t('turnos-sem-atingir-meta-de-aderencia') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ATS.title + ' - ' + triggerInfo.ATS.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.ATS.title + ' - ' + $t('explicacao-fca-6') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="ats-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input type="number" id="ats-unconformities" v-model="atsUnconformities" @keyup="sendATS" @change="sendATS"
                placeholder="1" @input="handleInput('atsUnconformities', $event)" min="1" style="width: 60px;" />
            </span>
          </div>
        </div>

      </div>

      <!-- Linha 2: ADI, ASW_RTA / ATM -->
      <div class="trigger-cards-row trigger-cards-row--mt">

        <!-- ADI: Dias Sem Atingir Meta -->
        <div class="trigger-card" :class="{ 'trigger-card--inactive': !adiActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-8" v-model="adiActive" @change="sendADI" class="trigger-checkBox" name="checkbox-8" value="true" switch :title="$t('dias-sem-atingir-meta')" v-marquee-overflow>
              {{ $t('dias-sem-atingir-meta') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ADI.title + ' - ' + triggerInfo.ADI.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.ADI.title + ' - ' + $t('explicacao-fca-7') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="adi-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input type="number" id="adi-unconformities" v-model="adiUnconformities" @keyup="sendADI" @change="sendADI"
                placeholder="1" @input="handleInput('adiUnconformities', $event)" min="1" style="width: 60px;" />
            </span>
          </div>
        </div>

        <!-- ASW_RTA: Semana Sem Atingir Meta (Aderência) -->
        <div v-if="isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !aswRtaActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-asw-rta" v-model="aswRtaActive" @change="sendASW_RTA" class="trigger-checkBox" switch :title="$t('semana-sem-atingir-meta-aderencia')" v-marquee-overflow>
              {{ $t('semana-sem-atingir-meta-aderencia') }}
            </b-form-checkbox>
            <b-icon v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.ASW_RTA.title.replace('_RTA', '') + ' - ' + $t('explicacao-asw-rta') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label>{{ $t('qtd-semanas') }}</label>
              <b-form-input type="number" v-model="aswRtaUnconformities" @change="sendASW_RTA" min="1" style="width: 60px;" />
            </span>
            <span class="trigger-field">
              <label>{{ $t('inicio-semana') }}</label>
              <b-form-select v-model="aswRtaWeekStartDay" @change="sendASW_RTA" style="width: 110px;">
                <b-form-select-option :value="0">Domingo</b-form-select-option>
                <b-form-select-option :value="1">Segunda</b-form-select-option>
                <b-form-select-option :value="2">Terça</b-form-select-option>
                <b-form-select-option :value="3">Quarta</b-form-select-option>
                <b-form-select-option :value="4">Quinta</b-form-select-option>
                <b-form-select-option :value="5">Sexta</b-form-select-option>
                <b-form-select-option :value="6">Sábado</b-form-select-option>
              </b-form-select>
            </span>
          </div>
        </div>

        <!-- ATM: Dias Sem Atingir Meta de Aderência do Turno -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !atmActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-9" v-model="atmActive" @change="sendATM" class="trigger-checkBox" name="checkbox-9" value="true" switch :title="$t('dias-sem-atingir-meta-de-aderencia-do-turno')" v-marquee-overflow>
              {{ $t('dias-sem-atingir-meta-de-aderencia-do-turno') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ATM.title + ' - ' + triggerInfo.ATM.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.ATM.title + ' - ' + $t('explicacao-fca-8') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="atm-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input type="number" id="atm-unconformities" v-model="atmUnconformities" @keyup="sendATM" @change="sendATM"
                placeholder="1" @input="handleInput('atmUnconformities', $event)" min="1" style="width: 60px;" />
            </span>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import MediatorTrigger from "../tools/MediatorTrigger"

export default {
  name: "TriggerReliability",
  props: ["triggerInfo", "reset", "triggerSelected", "show", "isRta"],
  inject: ["showInfo", "showResponsibles"],

  data() {
    return {
      altActive: false,
      aldActive: false,
      atsActive: false,
      atsUnconformities: 1,

      adiActive: false,
      adiUnconformities: 1,

      atmActive: false,
      atmUnconformities: 1,

      aswRtaActive: false,
      aswRtaUnconformities: 1,
      aswRtaWeekStartDay: 1,
    }
  },

  watch: {
    reset() {
      this.resetForm();
    },
  },

  methods: {
    loadForm(value) {
      if (!value.ALT) return
      this.loadData(value)
    },

    sendALT() {
      MediatorTrigger.notify({
        active: this.altActive,
      }, "setALT")
    },

    sendALD() {
      MediatorTrigger.notify({
        active: this.aldActive,
      }, "setALD")
    },

    sendATS() {
      MediatorTrigger.notify({
        active: this.atsActive,
        unconformities: this.atsUnconformities
      }, "setATS")
    },

    sendADI() {
      MediatorTrigger.notify({
        active: this.adiActive,
        unconformities: this.adiUnconformities
      }, "setADI")
    },

    sendATM() {
      MediatorTrigger.notify({
        active: this.atmActive,
        unconformities: this.atmUnconformities
      }, "setATM")
    },

    sendASW_RTA() {
      MediatorTrigger.notify({
        active: this.aswRtaActive,
        unconformities: this.aswRtaUnconformities,
        weekStartDay: this.aswRtaWeekStartDay
      }, "setASW_RTA")
    },

    loadData(value) {
      this.resetForm()

      if (value.ALT) this.altActive = value.ALT.active;
      if (value.ALD) this.aldActive = value.ALD.active;

      if (value.ATS) {
        this.atsActive = value.ATS.active;
        if (value.ATS.configurationJSON) {
          let configurationJSON = JSON.parse(value.ATS.configurationJSON)
          this.atsUnconformities = configurationJSON.unconformities;
        }
      }

      if (value.ADI) {
        this.adiActive = value.ADI.active;
        if (value.ADI.configurationJSON) {
          let configurationJSON = JSON.parse(value.ADI.configurationJSON)
          this.adiUnconformities = configurationJSON.unconformities;
        }
      }

      if (value.ATM) {
        this.atmActive = value.ATM.active;
        if (value.ATM.configurationJSON) {
          let configurationJSON = JSON.parse(value.ATM.configurationJSON)
          this.atmUnconformities = configurationJSON.unconformities;
        }
      }

      if (value.ASW_RTA) {
        this.aswRtaActive = value.ASW_RTA.active;
        if (value.ASW_RTA.configurationJSON) {
          let config = JSON.parse(value.ASW_RTA.configurationJSON)
          this.aswRtaUnconformities = config.unconformities || 1;
          this.aswRtaWeekStartDay = config.weekStartDay ?? 1;
        }
      }
    },

    openResponsible(triggercode) {
      this.showResponsible(triggercode)
    },

    resetForm() {
      this.altActive = false;
      this.aldActive = false;
      this.atsActive = false;
      this.atsUnconformities = 1;
      this.adiActive = false;
      this.adiUnconformities = 1;
      this.atmActive = false;
      this.atmUnconformities = 1;
      this.aswRtaActive = false;
      this.aswRtaUnconformities = 1;
      this.aswRtaWeekStartDay = 1;
    },

    handleInput(prop, event) {
      let cleanedValue = event.replace(/\D/g, '');
      if (prop == 'atsUnconformities')
        this.atsUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else if (prop == 'adiUnconformities')
        this.adiUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else
        this.atmUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
    }
  },

  mounted() {
    console.log("TriggerReliability - isRta:", this.isRta);
    MediatorTrigger.notify(this, "initTriggerReliability");
  }
}
</script>

<style scoped src="../style.css"></style>
